import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { FundsItemSelectedDesktop } from './desktop';
import { FundsItemSelectedMobile } from './mobile';
import { FundsItemSelectedTablet } from './tablet';

export namespace FundsItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['funds'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['funds']) => void;
    hideLateralBar?: boolean;
  }
}

export const FundsItemSelected: React.FC<FundsItemSelectedTypes.Props> = (props) => {
  const fundsSelectedItem = useBreakpointValue({
    base: <FundsItemSelectedMobile {...props} />,
    sm: <FundsItemSelectedTablet {...props} />,
    lg: <FundsItemSelectedDesktop {...props} />,
  });

  return fundsSelectedItem;
};
